import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import React from 'react'
import LuxuryPlusBenefitIcon from './LuxuryPlusBenefitIcon'

export default function LuxuryPlusBenefitsList({ benefits }) {
  return (
    <>
      {benefits.map(benefit => <BodyTextBlock
        key={benefit.type}
        variant="medium"
        startIcon={<LuxuryPlusBenefitIcon colour="loyalty" benefitType={benefit.type} />}
      >
        {benefit.title}
      </BodyTextBlock>)}
    </>
  )
}
